import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';
import { useEffect } from 'react';
import { setFromExplore } from 'features/explore/exploreSlice';
import { useSearchParams } from 'react-router-dom';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useFromExplore = (comes: boolean) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setFromExplore(comes));
  });
};

export const useSearchParamsObject = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params: { [k: string]: any } = {};

  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  return [params, setSearchParams];
};

export const useOnScrollEffect = (
  fun: React.EffectCallback,
  elementIds: string[],
  onWindow = false
) =>
  useEffect(() => {
    if (onWindow) window.addEventListener('scroll', fun);
    elementIds.forEach((elementId) =>
      document.getElementById(elementId)?.addEventListener('scroll', fun)
    );
    return () => {
      elementIds.forEach((elementId) =>
        document.getElementById(elementId)?.removeEventListener('scroll', fun)
      );
      if (onWindow) window.removeEventListener('scroll', fun);
    };
  }, [fun]);
